export * from './dom';
export * from './url';
export * from './entity';
export * from './time';
export * from './property';
export * from './common';
export * as data from './data';
export { default as httpRequest } from './request';
export { default as timezonesOptions } from './data/timezones';
export { default as lazyWithPreload } from './preloader';

export const zipRegex = {
  us: /^([0-9]{5})(?:[-\s]*([0-9]{4}))?$/,
  ca: /^([A-Z][0-9][A-Z])\s*([0-9][A-Z][0-9])$/,
};

export const removeWordEnding = (w: string) => `${w.slice(0, -1)}`;

export const arrayMove = (list: any[], fromIndex: number, toIndex: number) => {
  const result = Array.from(list);
  const [removed] = result.splice(fromIndex, 1);
  result.splice(toIndex, 0, removed);

  return result;
};

/*
 * Get namespace symbol from url
 * app.gymcloud.com => gymcloud
 * custom.app.gymcloud.com => custom
 * strongfirst.gymcloud.com => strongfirst
 */
export const getNamespaceSymbol = () => {
  if (process.env.TARGET_ENV !== 'production') {
    return window.localStorage.getItem('namespace') || 'gymcloud';
  }

  const { host } = window.location;
  const s = host.split('.');
  if (host.endsWith('gymcloud.com') && (s[0] !== 'app' || s[1] === 'app')) {
    return s[0];
  }

  return s[1];
};
